import { ModalProps } from "./ModalProps";
import { ModalBackdrop, ModalWrapper } from "./Modal.styles";

import { H5Tag, FlexComp, ParaTag } from "@tm/static";
import { theme } from "@tm/utility/global";

const Modal = ({
  children,
  modalWidth,
  modalHeading,
  modalHeadingComp,
  modalSubHeading,
  modalHeadingCtrMargin = "0 0 32px 0",
  closeButton,
  onModalClose,
  padding,
  modalType = "centered",
  backBtn,
  showBackBtn = false,
}: ModalProps) => {
  return (
    <>
      <ModalWrapper
        padding={padding}
        modalType={modalType}
        modalWidth={modalWidth}
      >
        {modalType === "fullPage" && showBackBtn ? (
          <FlexComp alignItems="center" margin={modalHeadingCtrMargin}>
            {backBtn && <span onClick={onModalClose}>{backBtn}</span>}
            {(modalHeading || modalSubHeading) &&
              (modalSubHeading ? (
                <FlexComp flexDirection="column" margin="0px">
                  {modalHeading && (
                    <ParaTag
                      fontSize="md"
                      margin={"0px 0px 0px 20px"}
                      color={theme.greyText}
                      fontWeight="bold"
                    >
                      {modalHeading}
                    </ParaTag>
                  )}
                  <ParaTag
                    fontSize="xs"
                    margin={"0px 0px 0px 20px"}
                    color={theme.greyText6}
                  >
                    {modalSubHeading}
                  </ParaTag>
                </FlexComp>
              ) : (
                <ParaTag
                  fontSize="md"
                  margin={"0px 0px 0px 20px"}
                  color={theme.greyText}
                  fontWeight="bold"
                >
                  {modalHeading}
                </ParaTag>
              ))}
            {modalHeadingComp && modalHeadingComp}
          </FlexComp>
        ) : (
          (modalHeading || closeButton || modalHeadingComp) && (
            <FlexComp
              alignItems="center"
              justifyContent="space-between"
              margin={modalHeadingCtrMargin}
            >
              {(modalHeading || modalSubHeading) && modalSubHeading ? (
                <FlexComp margin={"0px"} flexDirection="column">
                  {modalHeading && <H5Tag>{modalHeading}</H5Tag>}
                  <ParaTag fontSize="xs" color={theme.greyText}>
                    {modalSubHeading}
                  </ParaTag>
                </FlexComp>
              ) : (
                modalHeading && <H5Tag>{modalHeading}</H5Tag>
              )}
              {modalHeadingComp && modalHeadingComp}
              {closeButton && <span onClick={onModalClose}>{closeButton}</span>}
            </FlexComp>
          )
        )}

        {children}
      </ModalWrapper>
      <ModalBackdrop onClick={onModalClose} />
    </>
  );
};

export default Modal;
